import React from "react";
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { useState } from 'react';
import { useStateContext } from '../../context/ContextProvider';
import { useNavigate } from 'react-router-dom';

// Chakra imports
import {
    InputGroup,
    InputRightElement,
    Spinner,
    useToast,
    Stack,
    Alert,
    AlertIcon,
    Flex,
    Button,
    FormControl,
    FormLabel,
    Heading,
    Input,
    Link,
    Text,
} from "@chakra-ui/react";

// Assets
import signInImage from "../../assets/images/signInImage.png";
import axiosClient from "../../axios-client";


export default function Login() {

    const titleColor = "white";
    const textColor = "gray.400";
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const { setToken, isLoading, setIsLoading } = useStateContext()
    const [message, setMessage] = useState([])
    const toast = useToast()
    const navigate = useNavigate()
    const onSubmit = ev => {
        toast.closeAll()
        ev.preventDefault()
        setIsLoading(true)
        const payload = {
            email,
            password,
        }

        axiosClient.post('token/admin/', payload)
            .then(({ data }) => {
                setToken(data.access);
                setIsLoading(false);
                // localStorage.setItem("role", data.role)
                
            })
            .catch((err) => {
                const response = err.response;
                if (response.data.message === "Mot de passe incorrect") {
                    setMessage({ alert: response.data.message, target: "password" });
                }
                else if (response.data.message === "Votre compte est désactivé") { setMessage({ alert: response.data.message, target: "" }); }
                else {
                    setMessage({ alert: "Email incorrect", target: "email" });
                }

                setIsLoading(false)
                // console.error("erorrrrrrrrrrrr: ", err);
            })

    }
    const [showPassword, setShowPassword] = useState(false);
    const isFormFilled = email && password;

    return (
        <Flex position='relative' backgroundSize={'cover'} bgImage={signInImage} h={'100vh'}>
            <Flex
                flexDirection={'row'} h={'100vh'} w={'100%'}>

                <Flex h={'100%'} w={"100%"} alignItems={'center'} justifyContent={'center'}>
                    <Flex
                        w={{ base: "100%", sm: "90%", md: '60%', lg: '50%', xl: "30%" }}
                        backdropFilter='auto' backdropBlur='8px'
                        padding={10}
                        direction='column'
                        rounded={"xl"}
                        background='#89879636'
                    >
                        <div style={{ zIndex: 999 }}>
                            <Heading color={titleColor} fontSize='32px' mb='20px'>
                                Login
                            </Heading>
                            <Text
                                mb='36px'
                                ms='4px'
                                color={textColor}
                                fontWeight='bold'
                                fontSize='14px'>
                                Entrez votre adresse e-mail et votre mot de passe pour se connecter
                            </Text>
                            {message.alert &&
                                <Alert status='error' rounded="md">
                                    <AlertIcon />
                                    {message.alert}
                                </Alert>
                            }
                            <FormControl mb="3" id="email" isRequired >
                                <FormLabel color={titleColor} >Adresse email</FormLabel>
                                <Input color={titleColor} onChange={(e) => setEmail(e.target.value)} type="text" placeholder={'Tapez votre adresse email'} />
                            </FormControl>
                            <FormControl id="password" isRequired isInvalid={message.target === "password"}>
                                <FormLabel mb="3" color={titleColor}>Mot de passe</FormLabel>
                                <InputGroup mb="3">
                                    <Input color={titleColor} onChange={(e) => setPassword(e.target.value)} type={showPassword ? 'text' : 'password'} placeholder={'Tapez votre mot de passe'} />
                                    <InputRightElement h={'full'}>
                                        <Button
                                            color={titleColor}
                                            variant={'ghost'}
                                            _hover='none'
                                            onClick={() =>
                                                setShowPassword((showPassword) => !showPassword)
                                            }>
                                            {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                                        </Button>
                                    </InputRightElement>
                                </InputGroup>
                            </FormControl>


                            <Stack spacing={10}>
                                <Stack
                                    direction={{ base: 'column', sm: 'row' }}
                                    align={'start'}
                                    justify={'space-between'}>
                                    <Link href='/reset_password' color={'purple.100'}>Mot de passe oublié ?</Link>
                                </Stack>
                                <Button
                                    fontSize='13px'
                                    type="submit" colorScheme='blackAlpha' onClick={onSubmit} isLoading={isLoading}
                                    isDisabled={!isFormFilled}>
                                    {isLoading ? <Spinner size="sm" /> : "Connexion"}
                                </Button>
                            </Stack>



                        </div>

                    </Flex>

                </Flex>
            </Flex>


        </Flex>
    );
}

